<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import getAccountExceptions from '@gpx-spa/queries/src/getAccountExceptions';
import { displayExceptionEventTitle } from '@/utils/shipment-exception-display';
import { openExceptionsForDevice } from '@/utils/shipment-exception-device-join';

const props = defineProps<{
  accountId: number;
  deviceId: number;
}>();

const accountIdRef = computed(() => props.accountId);
const listParams = computed(() => ({
  status: 'open' as const,
  per_page: 100,
}));

const { data } = getAccountExceptions(accountIdRef, listParams);

const rows = computed(() =>
  openExceptionsForDevice(data.value?.data ?? [], props.deviceId),
);
</script>

<template>
  <ul v-if="rows.length > 0" class="space-y-1 text-sm">
    <li v-for="row in rows" :key="row.id">
      <RouterLink
        class="text-blue-700 hover:underline"
        :to="{ name: 'ShipmentDetailsView', params: { id: row.shipment_id } }"
      >
        {{ row.shipment?.name || `Shipment #${row.shipment_id}` }}
      </RouterLink>
      <span class="text-neutral-500"> · </span>
      <span>{{ displayExceptionEventTitle(row.type) }}</span>
    </li>
  </ul>
  <p v-else class="text-sm text-neutral-500">No open shipment exceptions.</p>
</template>
